import React, { useState } from 'react';
import {
  Box, Typography, Card, CardContent, Grid, Button, TextField, IconButton,
  Tooltip, Tabs, Tab, Divider, Chip, Alert, Dialog, DialogTitle,
  DialogContent, DialogActions, MenuItem, Snackbar,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import QrCodeIcon from '@mui/icons-material/QrCode2';
import ShareIcon from '@mui/icons-material/Share';
import AddIcon from '@mui/icons-material/Add';
import LinkIcon from '@mui/icons-material/Link';
import DataTable from '../../components/common/DataTable';

const mockLinks = [
  { id: 1, name: 'Personal Loan Campaign', url: 'https://www.imoney.my/apply?ref=CITIPRO', type: 'Personal Loan', clicks: 234, conversions: 18, status: 'Active', created: '2026-03-01' },
  { id: 2, name: 'Credit Card Promo', url: 'https://www.imoney.my/apply?ref=CITIPRO&product=cc', type: 'Credit Card', clicks: 156, conversions: 12, status: 'Active', created: '2026-03-10' },
  { id: 3, name: 'Housing Loan Referral', url: 'https://www.imoney.my/apply?ref=CITIPRO&product=hl', type: 'Housing Loan', clicks: 89, conversions: 5, status: 'Active', created: '2026-03-15' },
  { id: 4, name: 'Q1 Promo Link', url: 'https://www.imoney.my/apply?ref=CITIPRO&campaign=Q1', type: 'All Products', clicks: 412, conversions: 31, status: 'Expired', created: '2026-01-05' },
];

const mockQRs = [
  { id: 1, name: 'Office QR Poster', campaign: 'Walk-in Campaign', scans: 67, conversions: 8, status: 'Active' },
  { id: 2, name: 'Event Booth QR', campaign: 'Financial Fair 2026', scans: 145, conversions: 22, status: 'Active' },
  { id: 3, name: 'Business Card QR', campaign: 'General', scans: 34, conversions: 3, status: 'Active' },
];

export default function ReferralLinks() {
  const [tab, setTab] = useState(0);
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [showQRDialog, setShowQRDialog] = useState(false);
  const [snackbar, setSnackbar] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard?.writeText(text);
    setSnackbar(true);
  };

  const linkColumns = [
    { field: 'name', headerName: 'Link Name', width: 200 },
    { field: 'type', headerName: 'Product', renderCell: (row) => <Chip label={row.type} size="small" sx={{ backgroundColor: '#E3F2FD', color: '#1565C0' }} /> },
    { field: 'clicks', headerName: 'Clicks', align: 'right' },
    { field: 'conversions', headerName: 'Conversions', align: 'right' },
    { field: 'status', headerName: 'Status', renderCell: (row) => (
      <Chip label={row.status} size="small" sx={{
        backgroundColor: row.status === 'Active' ? '#E8F5E9' : '#FFEBEE',
        color: row.status === 'Active' ? '#2E7D32' : '#C62828', fontWeight: 600,
      }} />
    )},
    { field: 'created', headerName: 'Created' },
    { field: 'actions', headerName: 'Actions', sortable: false, renderCell: (row) => (
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <Tooltip title="Copy Link"><IconButton size="small" onClick={() => copyToClipboard(row.url)}><ContentCopyIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
        <Tooltip title="Generate QR"><IconButton size="small" onClick={() => setShowQRDialog(true)}><QrCodeIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
        <Tooltip title="Share"><IconButton size="small"><ShareIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
      </Box>
    )},
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#1B365D' }}>Referral Links & QR Codes</Typography>
          <Typography variant="body2" color="text.secondary">Manage your referral links and QR codes</Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setShowCreateDialog(true)}
          sx={{ borderRadius: 2, textTransform: 'none', backgroundColor: '#1B365D' }}>
          Create New Link
        </Button>
      </Box>

      {/* Main referral link */}
      <Card sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', mb: 3, background: 'linear-gradient(135deg, #1B365D 0%, #2C5282 100%)' }}>
        <CardContent sx={{ p: 3, color: 'white' }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ opacity: 0.8, mb: 0.5 }}>Your Main Referral Link</Typography>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <TextField
                  fullWidth value="https://www.imoney.my/apply?ref=CITIPRO" size="small"
                  InputProps={{
                    readOnly: true,
                    sx: { backgroundColor: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: 2, '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' } },
                  }}
                />
                <Button variant="contained" startIcon={<ContentCopyIcon />}
                  onClick={() => copyToClipboard('https://www.imoney.my/apply?ref=CITIPRO')}
                  sx={{ backgroundColor: '#00B894', '&:hover': { backgroundColor: '#00A37D' }, borderRadius: 2, textTransform: 'none', whiteSpace: 'nowrap' }}>
                  Copy
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>891</Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8 }}>Total Clicks</Typography>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>66</Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8 }}>Conversions</Typography>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>7.4%</Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8 }}>Conv. Rate</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3, '& .MuiTab-root': { textTransform: 'none', fontWeight: 600 } }}>
        <Tab icon={<LinkIcon />} iconPosition="start" label="Referral Links" />
        <Tab icon={<QrCodeIcon />} iconPosition="start" label="QR Codes" />
      </Tabs>

      {tab === 0 && <DataTable columns={linkColumns} rows={mockLinks} title="Your Referral Links" exportable />}

      {tab === 1 && (
        <Grid container spacing={3}>
          {mockQRs.map((qr) => (
            <Grid item xs={12} md={4} key={qr.id}>
              <Card sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  {/* QR placeholder */}
                  <Box sx={{
                    width: 180, height: 180, mx: 'auto', mb: 2, borderRadius: 2,
                    backgroundColor: '#F5F7FA', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    border: '2px dashed #C4CDD5',
                  }}>
                    <QrCodeIcon sx={{ fontSize: 80, color: '#1B365D' }} />
                  </Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{qr.name}</Typography>
                  <Typography variant="caption" color="text.secondary">{qr.campaign}</Typography>
                  <Divider sx={{ my: 1.5 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 700 }}>{qr.scans}</Typography>
                      <Typography variant="caption" color="text.secondary">Scans</Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 700 }}>{qr.conversions}</Typography>
                      <Typography variant="caption" color="text.secondary">Conversions</Typography>
                    </Box>
                  </Box>
                  <Button fullWidth variant="outlined" size="small" sx={{ mt: 2, borderRadius: 2, textTransform: 'none' }}>
                    Download QR
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Create Link Dialog */}
      <Dialog open={showCreateDialog} onClose={() => setShowCreateDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Create Referral Link</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField fullWidth label="Link Name *" placeholder="e.g., Personal Loan Campaign" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth select label="Product Type *" defaultValue="">
                <MenuItem value="all">All Products</MenuItem>
                <MenuItem value="personal">Personal Loan</MenuItem>
                <MenuItem value="credit_card">Credit Card</MenuItem>
                <MenuItem value="housing">Housing Loan</MenuItem>
                <MenuItem value="property">Property</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Campaign (optional)" placeholder="e.g., Q2 2026 Promo" />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowCreateDialog(false)} sx={{ textTransform: 'none' }}>Cancel</Button>
          <Button variant="contained" onClick={() => setShowCreateDialog(false)}
            sx={{ borderRadius: 2, textTransform: 'none', backgroundColor: '#1B365D' }}>
            Generate Link
          </Button>
        </DialogActions>
      </Dialog>

      {/* QR Dialog */}
      <Dialog open={showQRDialog} onClose={() => setShowQRDialog(false)} maxWidth="xs" fullWidth>
        <DialogContent sx={{ textAlign: 'center', py: 4 }}>
          <Box sx={{
            width: 200, height: 200, mx: 'auto', mb: 2, borderRadius: 2,
            backgroundColor: '#F5F7FA', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <QrCodeIcon sx={{ fontSize: 120, color: '#1B365D' }} />
          </Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>QR Code Generated</Typography>
          <Typography variant="caption" color="text.secondary">Scan to apply via your referral link</Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button variant="outlined" sx={{ borderRadius: 2, textTransform: 'none' }}>Download PNG</Button>
          <Button variant="contained" sx={{ borderRadius: 2, textTransform: 'none', backgroundColor: '#1B365D' }}>Download PDF Poster</Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar} autoHideDuration={2000} onClose={() => setSnackbar(false)} message="Link copied to clipboard!" />
    </Box>
  );
}
